import React from 'react';
import { Trash } from 'react-bootstrap-icons';

export default ({ id, onClick }) => <Trash size={20} id={id} onClick={onClick} />;
//   <i id={id} className="material-icons h3" onClick={onClick}>
//     delete
//   </i>
// );
